const enums = {
    COMPLIANCE: 'compliance',
    DFS: 'dfs',
    ACADEMY: 'academy',
    NEW_ACADEMY: 'newAcademy',
};

export default Object.freeze(enums);